import classNames from 'classnames';

import { getEarningsSurpriseColorState } from '../../../../lib/store/fundamental/helpers';
import { formatNumberWithSuffix } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import TrendUpIcon from '../../../../assets/img/green-arrow-angles.svg';
import TrendDownIcon from '../../../../assets/img/red-arrow-angles.svg';
import { formatEarningsCurrency, getFormattedSurpiseEpsWithSign } from '../../earningsCalendar.helpers';

import styles from './EarningsSurpriseValue.module.scss';

type Props = {
  surprise: string;
  surprisePercent: string;
  currency: string;
  symbol: string;
  showArrow?: boolean;
};

const EarningsSurpriseValue = ({ surprise, surprisePercent, currency, symbol, showArrow = false }: Props):
JSX.Element => {
  if (!surprise || !surprisePercent) {
    return <span className={styles.missingValue}>{INVALID_VALUE}</span>;
  }

  const colorState = getEarningsSurpriseColorState(surprise);
  const formattedSurprise = getFormattedSurpiseEpsWithSign(
    surprise,
    formatEarningsCurrency(surprise, currency, symbol),
  );
  const formattedPercent = formatNumberWithSuffix(Math.abs(parseFloat(surprisePercent)), '%');
  const isPositive = colorState === 'positive';
  const shouldShowArrow = showArrow && (colorState === 'positive' || colorState === 'negative');

  return (
    <span className={classNames(styles.surpriseValue, colorState && styles[colorState])}>
      {shouldShowArrow && (
        <img
          className={classNames(styles.trendIcon, { [styles.trendIconDown]: !isPositive })}
          src={isPositive ? TrendUpIcon : TrendDownIcon}
          alt=""
        />
      )}
      <span>{formattedSurprise}</span>
      <span>({formattedPercent})</span>
    </span>
  );
};

export default EarningsSurpriseValue;
